<ux-avatar class="user__avatar" [user]="user"></ux-avatar>
<div class="user__text">{{ user.firstName }}</div>
